module.exports = __webpack_public_path__ + "img/hub_dark_header.cbc76d7c.png";